import React from 'react';

import * as ParameterLibraryDAO from 'procedures/parameter-library/network/LibraryParameterDefinitionDAO';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface ParameterLibrarySettingsProps {
  section: SidebarConstants.Section;
}

export default function ParameterLibrarySettings({section}: ParameterLibrarySettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Parameter Library</div>
      <SidebarItem
        active={section === SidebarConstants.Section.PARAMETER_LIBRARY}
        icon={<BenchlingIcon className="result-icon" icon="parameters" />}
        name="Parameter library"
        link={ParameterLibraryDAO.libraryParameterDefinitionsListingURL()}
      />
    </div>
  );
}
